export default __webpack_public_path__ + "static/media/2481.e3c3e102.png";